import { render, staticRenderFns } from "./room-role.vue?vue&type=template&id=27877864&scoped=true&"
import script from "./room-role.vue?vue&type=script&lang=js&"
export * from "./room-role.vue?vue&type=script&lang=js&"
import style0 from "./room-role.vue?vue&type=style&index=0&id=27877864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27877864",
  null
  
)

export default component.exports